export {}
;(window as any).recaptchaSiteKey = '6Lc-Pg4jAAAAAF_RSuoMhAeKZOeZabD9o7w-JCWN'
